import React from "react";
import { SimpleGrid, Text, Flex, Icon, type IconProps } from "@chakra-ui/react";
import { Link } from "ui/link";
import {
  ReverseEtlIcon,
  CustomerStudioIcon,
  MatchBoosterIcon,
  IdentityResolutionIcon,
  EventCollectionIcon,
  CampaignIntelligenceIcon,
} from "ui/icons";

type LinkProps = {
  label: string;
  href: string;
  icon: (props: IconProps) => JSX.Element;
};

function ProductLink({ label, href, icon }: LinkProps) {
  return (
    <Link
      width="100%"
      href={href}
      role="group"
      fontSize="sm"
      fontWeight="normal"
      textDecoration="none"
      flexDir="column"
      alignItems="start"
      _hover={{ textDecoration: "none" }}
    >
      <Flex align="center" gap={2} transition="all .15s ease" _groupHover={{ color: "grass" }}>
        <Icon as={icon} color="grass" boxSize={5} />

        <Text as="span" display="flex" fontSize="sm">
          {label}
        </Text>
      </Flex>
    </Link>
  );
}

export function BusinessCardDetails() {
  return (
    <SimpleGrid columns={{ base: 1, md: 2 }} gap={5}>
      <Flex direction="column" gap={5}>
        <ProductLink label="Reverse ETL" href="/platform/reverse-etl" icon={ReverseEtlIcon} />
        <ProductLink label="Customer Studio Platform" href="/platform/customer-studio" icon={CustomerStudioIcon} />
        <ProductLink label="Identity Resolution" href="/platform/identity-resolution" icon={IdentityResolutionIcon} />
      </Flex>
      <Flex direction="column" gap={5}>
        <ProductLink label="Hightouch Events" href="/platform/events" icon={EventCollectionIcon} />
        <ProductLink
          label="Campaign Intelligence"
          href="/platform/campaign-intelligence"
          icon={CampaignIntelligenceIcon}
        />
        <ProductLink label="Match Booster" href="/platform/match-booster" icon={MatchBoosterIcon} />
      </Flex>
    </SimpleGrid>
  );
}
